import { defineComponent as _defineComponent } from 'vue'

import { defineComponent, ref } from 'vue'
import { ValidationObserver } from 'vee-validate'

import LButton from '@/components/core/Button.vue'
import LInput from '@/components/core/form/Input.vue'
import FormGroup from '@/components/core/form/FormGroup.vue'
import LCard from '@/components/core/card/Card.vue'
import LCardHeader from '@/components/core/card/CardHeader.vue'
import LCardTitle from '@/components/core/card/CardTitle.vue'
import LCardSubtitle from '@/components/core/card/CardSubtitle.vue'
import LCardContent from '@/components/core/card/CardContent.vue'
import LCardFooter from '@/components/core/card/CardFooter.vue'
import { useResetPassword } from '@/composables/auth'

const __default__ = defineComponent({
  layout: 'centered',
  head() {
    return {
      title: `${this.$t('forgotPassword')} — Lambus`,
    }
  },
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'password-reset',
  setup(__props) {

const { mutate: resetPassword } = useResetPassword()

const email = ref('')

function handleFormSubmit() {
  resetPassword(email.value)
}

return { __sfc: true,resetPassword, email, handleFormSubmit, ValidationObserver, LButton, LInput, FormGroup, LCard, LCardHeader, LCardTitle, LCardSubtitle, LCardContent, LCardFooter }
}

})